// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3fmni","alert":"SettungsInbox_alert__2w7XE"};